var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSummarizerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "summarizer-icon",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.81 21.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.81,5.35h0c-2.42.65-4.69,2.93-5.35,5.35h0c-.65-2.42-2.93-4.69-5.35-5.35h0c2.42-.65,4.69-2.93,5.35-5.35h0c.65,2.42,2.93,4.69,5.35,5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67,21.82H0v-2.35h8.67c1.77,0,2.99-.5,3.89-1.4l1.71-1.71c1.35-1.35,2.64-2.09,4.55-2.09h1v2.35h-1c-1.28,0-2.48.5-3.39,1.4l-1.71,1.71c-1.35,1.35-3.14,2.09-5.05,2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.82,16.61h-4.97c-1.91,0-3.21-.74-4.56-2.09l-1.71-1.71c-.91-.91-2.17-1.4-3.88-1.4H0v-2.35h4.71c1.91,0,3.7.74,5.05,2.09l1.71,1.71c.91.91,2.11,1.4,3.39,1.4h4.97v2.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 14.26,
    width: 19.82,
    height: 2.35
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummarizerIcon);
export default __webpack_public_path__ + "static/media/summarizer-icon.1460b1c09115958b353e26db3c744006.svg";
export { ForwardRef as ReactComponent };